<template>
    <div class="upload-copyright" v-loading.fullscreen.lock="pageLoading" element-loading-text="数据上传中，请耐心等待……">
        <xi-top></xi-top>
        <div class="upload-banner">
            <span>{{ $t('comb.uploadWork') }}</span>
        </div>
        <el-form :model="copyright" ref="copyright" :rules="copyRules" class="copyright-item">
            <p style="margin: 30px 0;font-size: 12px; color: #ccc;">温馨提示：如果您在上传版权过程中，有任何疑问和建议，请通过邮箱与我们联系，我们将竭诚为您服务。
                有声化平台官方邮箱：a.plus@ximalaya.com</p>
            <el-row>
                <span class="label">{{ $t('comb.baseInfo') }}</span>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item prop="bookName">
                        <el-input v-model="copyright.bookName" :placeholder="$t('sen.bookNameMissing')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item prop="author">
                        <el-input v-model="copyright.author" :placeholder="$t('sen.writerMissing')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item>
                        <el-cascader
                                expand-trigger="click"
                                :show-all-levels="false"
                                :options="categoryList"
                                v-model="copyright.category"
                                :props="categoryProps"
                                filterable>
                        </el-cascader>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :span="12">
                    <el-form-item>
                        <el-input v-model="copyright.publisher" :placeholder="$t('sen.publisherHolder')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="ISBN">
                        <el-input v-model="copyright.ISBN" :placeholder="$t('sen.ISBNPlaceHolder')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-form-item prop="intro">
                    <el-input :rows="4" v-model="copyright.intro" type="textarea" :placeholder="$t('comb.workIntro')"></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-col class="upload-block">
                    <span>{{ $t('comb.uploadCover')}}</span>
                    <el-form-item class="cover-img-wrapper" prop="coverImg">
                        <el-upload class="cover-img-uploader" action="/dtres/backend/album/upload"
                                   :show-file-list="false" accept="image/jpeg,image/png,image/bmp"
                                   :on-success="handleCoverImgSuccess"
                                   :before-upload="beforeCoverImgUpload">
                            <img v-if="copyright.coverImg" :src="`${UPLOAD_IMG_HOST}${copyright.coverImg}`" class="cover-img">
                            <i v-else class="el-icon-plus"></i>
                        </el-upload>
                        <p style="line-height: 28px;color: #7b9d85;margin-left: 20px;">
                            封面图片需包含书籍名和作者,最佳分辨率为500*500。<br>
                            上传的图片将成为该版权内容有声作品的封面图片，向主播和读者展示。请慎重选择。
                        </p>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="upload-block">
                    <el-form-item prop="workList">
                        <span>{{ $t('comb.workFile') }} （只支持txt, doc, docx, pdf格式文件）</span>
                        <div class="upload-files-name" v-for="(workFile, index) in copyright.workList">
                            <el-tag @close="removeFile(index, 'workList')" :closable="true">{{workFile.name || workFile.fileName}}</el-tag>
                        </div>
                        <div class="upload-btn" @click="uploadFile">
                            <input type="file" @change="addWork" data-list-type="workList" multiple="multiple" accept=".txt,.docx,application/pdf,application/msword">
                            <i class="el-icon-upload2"></i>
                            <span>{{ $t('word.add') }}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-form-item prop="words">
                    <el-row style="display: flex;align-items: center;">
                        <span style="margin-right: 15px;line-height: 50px;padding-bottom: 10px;">内容总字数</span>
                        <div>
                            <el-input-number size="small" v-model="copyright.words" :controls="false"></el-input-number>
                        </div>
                    </el-row>
                </el-form-item>
            </el-row>
            <el-row>
                <span class="label">{{ $t('comb.authorization') }}</span>
            </el-row>
            <el-row>
                <el-col :span="11">
                    <span style="margin-bottom: 20px;display: block;">请选择您的作品有声化费用承担方式</span>
                </el-col>
                <el-col :span="4">
                    <router-link style="color: #fc5832;font-size: 12px;" :to="{name: 'helpCenterCopyrightManagement', hash: '#fee'}" target="_blank">（查看区别）</router-link>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 30px;">
                <el-radio-group @change="changePayType" v-model="isCopyrighterPay">
                    <el-radio class="el-col-24" style="color: #666; margin-bottom: 15px;" :label="false">不承担录制费用，由喜马拉雅代理制作</el-radio>
                    <el-radio class="el-col-24" style="margin-left: 0;color: #666;" :label="true">愿意承担录制费用</el-radio>
                </el-radio-group>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <span style="margin-bottom: 20px;display: block;">您希望在平台发布的作品</span>
                </el-col>
                <el-col :span="4">
                    <router-link style="color: #fc5832;font-size: 12px;" :to="{name: 'helpCenterCopyrightManagement', hash: '#isSolo'}" target="_blank">(了解详情)</router-link>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 30px;">
                <el-radio-group @change="changeLicense" v-model="isSoloLicense">
                    <el-radio class="el-col-24" style="color: #666; margin-bottom: 15px;" :label="true">独家授权给喜马拉雅</el-radio>
                    <transition name="fade">
                        <el-radio v-if="isCopyrighterPay" class="el-col-24" style="margin-left: 0; color: #666;" :label="false">非独家授权给喜马拉雅</el-radio>
                    </transition>
                </el-radio-group>
            </el-row>
            <el-row>
                <span style="font-size: 14px;margin-bottom: 10px;display: block;">{{ $t('comb.uploadCopyrightFile')}}（支持pdf和图片）</span>
            </el-row>
            <el-row>
                <el-col v-if="$route.params.bookId" key="$route.params.bookId" :span="16" style="line-height: 36px;">
                    <span v-if="copyright.authFile.name" class="upload-label">{{ copyright.authFile.name }}</span>
                    <a v-else :href="`${$store.state.UPLOAD_IMG_HOST}${copyright.authFile}`" class="uploaded-file" target="_blank">已上传的认证文件</a>
                </el-col>
                <el-col v-else :span="16" style="line-height: 36px;">
                    <span v-if="copyright.authFile" class="upload-label">{{ copyright.authFile.name }}</span>
                    <span v-else class="upload-label">作品版权授权书</span>
                </el-col>
                <el-col :span="4">
                    <el-form-item prop="authFile" style="margin-bottom: 0px">
                        <div class="upload-btn" @click="uploadFile">
                            <input type="file" @change="addAuthWork" data-list-type="authFile" accept="application/pdf, image/*">
                            <span v-if="copyright.authFile" class="upload-link-label">{{ $t('word.replace') }}</span>
                            <span v-else class="upload-link-label">{{ $t('word.add') }}</span>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="4" style="line-height: 36px;">
                    <a class="upload-link-label" v-if="$store.state.user.author.type === 1" href="http://fdfs.xmcdn.com/group34/M04/EA/17/wKgJYFnpcxnA8_z9AABRG2RdMFY63.docx" download="授权书（个人）-附身份证复印件.docx">{{ $t('word.download') }}{{ $t('word.demo') }}</a>
                    <a class="upload-link-label" v-if="$store.state.user.author.type === 2" href="http://fdfs.xmcdn.com/group34/M04/EA/1C/wKgJYFnpc0iB2ChcAABRFbmfFIM39.docx" download="授权书（公司）-附营业执照.docx">{{ $t('word.download') }}{{ $t('word.demo') }}</a>
                </el-col>
            </el-row>
            <el-row v-if="$store.state.user.author.type === 2">
                <el-col v-if="$route.params.bookId" key="$route.params.bookId" :span="16" style="line-height: 36px;">
                    <span v-if="copyright.retrospectFile.name" class="upload-label">{{ copyright.retrospectFile.name }}</span>
                    <a v-else :href="`${$store.state.UPLOAD_IMG_HOST}${copyright.retrospectFile}`" class="uploaded-file" target="_blank">已上传的追溯文件</a>
                </el-col>
                <el-col v-else :span="16" style="line-height: 36px;">
                    <span v-if="copyright.retrospectFile" class="upload-label">{{ copyright.retrospectFile.name }}</span>
                    <span v-else class="upload-label">版权追溯文件</span>
                </el-col>
                <el-col :span="4">
                    <el-form-item prop="retrospectFile" style="margin-bottom: 0px">
                        <div class="upload-btn" @click="uploadFile">
                            <input type="file" @change="addAuthWork" data-list-type="retrospectFile" accept="application/pdf, image/*">
                            <span v-if="copyright.retrospectFile" class="upload-link-label">{{ $t('word.replace') }}</span>
                            <span v-else class="upload-link-label">{{ $t('word.add') }}</span>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="4" style="line-height: 36px;">
                    <el-tooltip effect="dark" placement="bottom">
                        <span class="upload-link-label" style="color:#382471">说明</span>
                        <div slot="content">
                            请提供《出版合同》，《数字出版协议》等版权追溯<br>
                            文件，以证明贵社拥有有声改编权。如原合同没有这<br>
                            项权利的，需要跟作者补签协议，并重新提交追溯文件。
                        </div>
                    </el-tooltip>
                </el-col>
            </el-row>
            <el-row style="margin: 30px 0 15px; font-size: 14px;">
                <span>版权有效期</span>
                <el-tooltip content="版权授权时间应大于三年" placement="right">
                    <i class="icon icon-18 va-sub icon-question-circle" style="margin-left: 10px;background-color: black;border-radius: 50%;"></i>
                </el-tooltip>
            </el-row>
            <el-row>
                <el-row>
                    <el-form-item prop="copyrightLimit">
                        <el-date-picker
                                :editable="false"
                                :picker-options="pickerOptions"
                                v-model="copyright.copyrightLimit"
                                :placeholder="$t('sen.copyrightLimitMissing')">
                        </el-date-picker>
                    </el-form-item>
                </el-row>
            </el-row>
            <el-row style="margin-bottom: 60px;">
                <el-checkbox style="color: #666; float: none;" v-model="isAgree">
                    {{ $t('word.agree') }}<el-button type="text" @click.native="openProtocol">{{ protocolText }}</el-button>
                </el-checkbox>
            </el-row>
            <el-row class="buttons">
                <el-button @click="submit" type="primary" :disabled="!isAgree || pageLoading">{{ $t('comb.commitToAudit') }}</el-button>
            </el-row>
        </el-form>
        <el-dialog :title="$t('comb.licenseAgreement')" v-model="showSoloProtocol">
            <release-solo-protocol @agreementResult="setAgreementResult"></release-solo-protocol>
        </el-dialog>
        <el-dialog :title="$t('comb.licenseAgreement')" v-model="showProtocol">
            <release-protocol @agreementResult="setAgreementResult"></release-protocol>
        </el-dialog>
        <el-dialog :title="$t('comb.licenseAgreement')" v-model="showSoloCustomPayProtocol">
            <release-solo-custom-pay-protocol @agreementResult="setAgreementResult"></release-solo-custom-pay-protocol>
        </el-dialog>
        <xi-footer></xi-footer>
    </div>
</template>
<script>
    import axios from 'axios';
    import XiFooter from '../components/Footer.vue';
    import XiTop from '../components/Top.vue';
    import each from 'lodash/each';
    import dateformat from 'dateformat';
    import releaseSoloCustomPayProtocol from '../components/ReleaseSoloCustomPayProtocol.vue';
    import releaseSoloProtocol from '../components/ReleaseSoloProtocol.vue';
    import releaseProtocol from '../components/ReleaseProtocol.vue';
    export default {
        components: {
            axios, releaseSoloProtocol, releaseProtocol, releaseSoloCustomPayProtocol, XiFooter, XiTop
        },
        data() {
            var authFileNotNull = (rule, value, callback) => {
                if(!value && value.length === 0) {
                    callback(new Error(this.$i18n.t('sen.authFileMissing')));
                } else {
                    callback();
                }
            };
            var retrospectFileNotNull = (rule, value, callback) => {
                if(!value || value.length === 0) {
                  callback(new Error(this.$i18n.t('sen.retrospectFileMissing')));
                } else {
                  callback();
                }
            };
            var workListValid = (rule, value, callback) => {
                if(!value || value.length === 0) {
                    callback(new Error(this.$i18n.t('sen.workListMissing')));
                }
                each(value, file => {
                    if(!file.size) {
                        callback(new Error('作品附件内容为空，请重新选择'));
                    }
                });
                callback();
            };
            return {
                pickerOptions: {
                  disabledDate(time) {
                    const curDate = new Date();
                    return time.getTime() < curDate.setFullYear(curDate.getFullYear() + 3, curDate.getMonth(), curDate.getDate() - 1);
                  }
                },
                showProtocol: false,
                showSoloProtocol: false,
                showSoloCustomPayProtocol: false,
                pageLoading: false,
                categoryProps: {
                  value: 'categoryId',
                  label: 'name',
                  children: 'children'
                },
                isAgree: false,
                isCopyrighterPay: false,
                isSoloLicense: true,
                protocolText: this.$i18n.t('word.solo')+this.$i18n.t('comb.licenseAgreement'),
                imgIndex: 0,
                categoryList: [],
                copyright: {
                    coverImg: '',
                    bookName: '',
                    category: [1, 6],
                    publisher: '',
                    author: '',
                    intro: '',
                    ISBN: '',
                    words: '',
                    copyrightLimit: '',
                    lowRetail: 0,
                    highRetail: 0,
                    workList: [],
                    authFile: '',
                    retrospectFile: ''
                },
                copyRules: {
                    coverImg: [
                        { required: true, message: this.$i18n.t('sen.coverImgMissing'), trigger: 'change'}
                    ],
                    bookName: [
                        { required: true, message: this.$i18n.t('sen.workNameMissing'), trigger: 'blur'},
                        { max: 100, message: '书籍名称长度应当在100字以内', trigger: 'blur' }
                    ],
                    ISBN: { max: 100, message: 'ISBN长度应当在100字以内', trigger: 'blur' },
                    copyrightLimit: [
                        { required: true, type: 'date', message: this.$i18n.t('sen.copyrightLimitMissing'), trigger: 'change'}
                    ],
                    author: [
                        { required: true, message: this.$i18n.t('sen.writerMissing'), trigger: 'blur'},
                        { max: 50, message: '作家名称长度应当在50字以内', trigger: 'blur' }
                    ],
                    intro: {max: 2500, message: '作品简介长度应当在2500字以内', trigger: 'blur'},
                    workList: [
                        {validator: workListValid, trigger: 'change'}
                    ],
                    authFile: [
                        {validator: authFileNotNull, trigger: 'change'}
                    ],
                    retrospectFile: [
                        {validator: retrospectFileNotNull, trigger: 'change'}
                    ]
                }
            }
        },
        beforeMount() {
          this.setXMLog();
          this.getCategories();
          const curDate = new Date();
          this.copyright.copyrightLimit = new Date(curDate.setFullYear(curDate.getFullYear() + 3, curDate.getMonth(), curDate.getDate()));
        },
        methods: {
            getBookInfo(bookId) {
              const that = this;
              axios.get(`/api/book/detail/${bookId}`).then(res => {
                const book = res.data.data;
                const limitDate = book.bookContract.copyrightDeadline;
                if(limitDate > that.copyright.copyrightLimit) {
                  that.copyright.copyrightLimit = new Date(limitDate);
                }
                that.copyright.coverImg = book.coverImg;
                that.copyright.bookName = book.title;
                that.copyright.author = book.author;
                that.copyright.publisher = book.publishCompany;
                that.copyright.intro = book.intro;
                that.copyright.ISBN = book.isbn;
                that.copyright.words = book.words;
                that.copyright.retrospectFile = book.bookContract.retrospectFileUrl;
                that.copyright.authFile = book.bookContract.authorizedFileUrl;
                that.isSoloLicense = book.bookContract.exclusive;
                that.isCopyrighterPay = book.bookContract.ownerCoverCost;
                that.copyright.workList = book.attachmentList;

                // 处理类型
                var curCategory = that.copyright.category;
                curCategory.splice(0,curCategory.length)
                each(that.categoryList, topLevel => {
                  if(book.categoryId === topLevel.categoryId) {
                    curCategory.push(book.categoryId);
                    return;
                  }
                  if(topLevel.children && topLevel.children.length > 0) {
                    each(topLevel.children, subLevel => {
                      if(book.categoryId === subLevel.categoryId) {
                        curCategory.push(topLevel.categoryId);
                        curCategory.push(subLevel.categoryId);
                        return;
                      }
                    })
                  }
                })
              }).catch(error => {
                this.$message({
                  type: 'error',
                  message: error.message
                });
              });

            },
            setAgreementResult (value) {
              this.isAgree = value;
              this.showSoloCustomPayProtocol = false;
              this.showSoloProtocol = false;
              this.showProtocol = false;
            },
            openProtocol () {
              this.isSoloLicense? (this.isCopyrighterPay?this.showSoloCustomPayProtocol = true: this.showSoloProtocol = true): this.showProtocol = true;
            },
            changeLicense () {
              this.isAgree = false;
              this.protocolText = (this.isSoloLicense?this.$i18n.t('word.solo'): '') + this.$i18n.t('comb.licenseAgreement');
            },
            changePayType () {
              this.isAgree = false;
              this.isSoloLicense = this.isCopyrighterPay? this.isSoloLicense: true;
            },
            getCategories() {
                const that = this;
                axios.get('/api/audio/categories').then(res => {
                  const list = res.data.data;
                    each(list, topLevel => {
                      if(topLevel.children.length === 0) {
                        delete topLevel.children;
                      } else {
                        each(topLevel.children, subLevel => {
                          delete subLevel.children;
                        });
                      }
                    });
                  that.categoryList = list;

                  if(that.$route.params.bookId) {
                    that.getBookInfo(this.$route.params.bookId);
                  }
                }).catch(error => {
                    this.$message({
                        type: 'error',
                        message: error.message
                    });
                });
            },
            // 认证文件上传
            uploadFile(e) {
                const file = e.target.parentNode.firstChild;
                file.click();
            },
            // 添加附件
            addWork(e) {
                const listType = e.target.dataset.listType;
                if (e.target.files.length > 0) {
                    this.copyright[listType].push(e.target.files[0]);
                }
                this.$refs['copyright'].validateField(listType);
            },
            // 添加授权文件
            addAuthWork(e) {
                const listType = e.target.dataset.listType;
                if (e.target.files.length > 0) {
                  this.copyright[listType] = e.target.files[0];
                }
                this.$refs['copyright'].validateField(listType);
            },
            // 删除附件
            removeFile(fileIndex, listType) {
                this.copyright[listType].splice(fileIndex, 1);
                this.$refs['copyright'].validateField(listType);
            },
            // 图片上传成功
            handleCoverImgSuccess(res) {
                this.copyright.coverImg = res.data[0].dfsId;
                this.$refs['copyright'].validateField('coverImg');
            },
            beforeCoverImgUpload(file) {
                const isLt5M = file.size / 1024 / 1024 < 5;

                if (!isLt5M) {
                    this.$message.error(this.$i18n.t('sen.pictureUploadLimit'));
                }
                return isLt5M;
            },
            submit() {
                const that = this;
                const commitUrl = that.$route.params.bookId? '/api/book/modify': '/api/book/save';
                that.pageLoading = true;
                // 数据验证
                that.$refs['copyright'].validate((valid) => {
                    if(valid) {
                        // 提交数据
                        const formData = new FormData();
                        const data = that.copyright;
                        // 合同版权对象
                        let contract = {
                          exclusive: that.isSoloLicense,
                          copyrightDeadline: dateformat(data.copyrightLimit, 'yyyy-mm-dd'),
                          ownerCoverCost: that.isCopyrighterPay,
                        };
                        const categoryString = data.category[data.category.length-1];
                        const book = {
                            'title': data.bookName,
                            'categoryId': categoryString,
                            'isbn': data.ISBN,
                            'publishCompany': data.publisher,
                            'coverImg': data.coverImg,
                            'intro': data.intro,
                            'words': data.words,
                            'author': data.author,
                            'bookContract': contract,
                            'attachmentList': []
                        }
                        if(that.$route.params.bookId) {
                          book.id = that.$route.params.bookId;
                        }
                        if(typeof data.authFile === "string") {
                          book.bookContract.authorizedFileUrl = data.authFile;
                        } else {
                          formData.append('authorizedFile', data.authFile);
                        }
                        if(typeof data.retrospectFile === "string") {
                          book.bookContract.retrospectFileUrl = data.retrospectFile;
                        } else {
                          formData.append('retrospectFile', data.retrospectFile);
                        }

                        const workLength = data.workList.length;
                        for(let i = 0; i < workLength; i++) {
                          data.workList[i].bookId? book.attachmentList.push(data.workList[i])
                            :formData.append('files', data.workList[i]);
                        }
                        formData.append('book', JSON.stringify(book));
                        axios.post(commitUrl, formData).then(res => {
                            if(res.data.code === 200) {
                                that.$router.push({name: 'worksManagement'})
                            } else {
                                that.$notify({
                                  type: 'warning',
                                  message: res.data.message,
                                  duration: 0
                                });
                                that.pageLoading = false;
                            }
                        }).catch(function(error) {
                            that.$notify({
                              type: 'warning',
                              message: '文件上传失败，请联系客服',
                              duration: 0
                            });
                            that.pageLoading = false;
                        });
                    } else {
                      that.pageLoading = false;
                    }
                });
            },
            setXMLog () {
                xmLog('pv.create', {
                  item: "有声化版权上传页"
                }),
                xmLog("pv.send", "event", {
                    serviceId: "aBookView",
                    item: "有声化版权上传页"
                })
            }
        },
        computed: {
            UPLOAD_IMG_HOST() {
                return this.$store.state.UPLOAD_IMG_HOST;
            },
            IMG_HOST() {
              return this.$store.state.IMG_HOST;
            }
        }
    }
</script>
<style lang="sass">
    @import '../../sass/icons.scss';
    @import '../../sass/copyright/uploadCopyright.scss';
</style>



// WEBPACK FOOTER //
// UploadCopyright.vue?18e04264